import React from "react";

import './styles.scss';

import {Link} from "../../../../../../../../../router";
import Ripple from "../../../../../../../../dumb/Ripple";
import Caret from "../../../../../Caret";

import MerchantNavigationItemInner from "../MerchantNavigationItemInner";
import {isUserAccessed} from "../../../../../../../../../emitters/account";

const permissionCheck = (el) => {
  const permissions = el.permissions || [];
  if (!permissions.length) return true;
  return permissions.every((pemission) => isUserAccessed(pemission));
}

export default ({id, className, subLinks = [], active, onClick, ...props}) => {
  const [open, setStateOpen] = React.useState(active);

  const classNamesRipple = [className, 'merchant-nav-list', open && 'open'].join(' ');
  const classNamesList = ['merchant-nav-list__links', open && 'open'].join(' ');

  return (
    <>
      <Ripple
        className={classNamesRipple}
        onClick={() => setStateOpen(!open)}
        data-testid={id}
        disabled={active}
      >
        <MerchantNavigationItemInner {...props} />
        <Caret />
      </Ripple>
      <div className={classNamesList}>
        {subLinks.filter(permissionCheck).map((el, i) => (
          <Link
            key={i}
            href={el.link}
            onClick={onClick}
            data-testid={el.id}
            className="merchant-nav-list__link"
          >
            {el.name}
          </Link>
        ))}
      </div>
    </>
  );
}
